import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import React, { useState, useEffect } from "react";
import InputForm, { AutoCompleteValue } from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import DateForm from "../../Components/DateForm/DateForm";
import moment from "moment";
import ButtonComponent from "../../Components/ButtonForm/Button";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import {
  insertUpdateNomineedetails,
  getNomineeDetailsByMemberId,
  getNomineeDetailsById,
  configValue,
  getMemberRegistrationStatusByMemberId,
  insertUpdateNomineeIsAgreedTC,
  getConfigValues,
  CommonDropdownData,
} from "../../Helpers/APIEndPoints/EndPoints";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import notify from "../../Helpers/ToastNotification";
import BaseModal from "../../Components/BaseModel/BaseModel";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { DropdownTypeId } from "../../Helpers/Enums/DropdownTypeId";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { randomDate, randomEmail, randomMobile, randomNumber, randomString } from "../../Helpers/Common";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { enableTestData } from "../../Helpers/Constants/Constants";
import { NomineeLimit } from "../../Helpers/Enums/Enum";

const NomineeDetails = (props) => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [termscondition, setTermscondition] = useState([]);
  const [nomineeid, setNomineeId] = useState(0);
  const [totalshare, setTotalShare] = useState<number>();
  const [isModalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState({
    nomineename: "",
    nomineerelations: null,
    dob: null,
    nomineeminor: false,
    share: null,
    address: "",
    terms: false,
    guardianname: "",
    guardianrelation: null,
    guardianaddress: "",
    EmailId: "",
    ContactNo: null,
  });
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isTermsDisabled, setIsTermsDisabled] = useState(false);
  const [nomDetails, setNomDetails] = useState([
    {
      nomineename: "",
      nomineerelations: null,
      dob: null,
      nomineeminor: false,
      share: null,
      address: "",
      terms: false,
      guardianname: "",
      guardianrelation: null,
      guardianaddress: "",
    },
  ]);
  const [griddata, setGridData] = useState([]);
  const [dataCount, setDataCount] = React.useState<number>(0);
  const [dashboardPageSize, setDashboardPageSize] = React.useState<number>(10);
  const [searchText, setSearchText] = React.useState<string>("");
  const [showNextButton, setShowNextButton] = useState(false);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [disableAddButton, setDisableAddButton] = useState(true);

  const [nomineeRelationData, setNomineeRelationData] = React.useState([]);

  // const nomineeRelationData = [
  //   { value: 1, label: "Spouse" },
  //   { value: 2, label: "Father" },
  //   { value: 3, label: "Mother" },
  //   { value: 4, label: "Daughter" },
  //   { value: 5, label: "Son" },
  // ];

  let stateid = 0;

  useEffect(() => {
    getMemberIdStatusDetails();
    terms();
    getGridData();
    getRelationDropdownData();
  }, []);

  const terms = async () => {
    let temp = [];
    let terms = ["terms1", "terms2", "terms3", "terms4", "terms5"];
    // terms.map(async (d) => {
    //   let val = `${configValue}/${d}`;
    //   const configdata = await APICall(val, {}, HttpMethod.GET);
    //   let obj = {
    //     d: configdata.Data.Value,
    //   };
    //   temp.push(obj);
    // });
    let param = `${getConfigValues}`;
    const getdata = await APICall(param, { Keys: terms });
    temp = getdata.Data?.map((c) => c?.Value);
    

    setTermscondition(temp);
  };
  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };
  const [error, setError] = React.useState<any>({});
  const [statusData, setStatusData] = React.useState(props?.statusData);
  const { selectNextTab, selectPreviousTab } = props;
  const memberid = GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  
  const dashboardOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: dashboardPageSize,
    serverSide: false,
    rowsPerPageOptions: [] as any[],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
  };
  const dashboardGridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
        filter: true,
        sort: true,
      },
    },
    {
      name: "nomineename",
      label: "Nominee Name",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },

    {
      name: "nomineerelations",
      label: "Nominee Relation",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "address",
      label: "Address",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "dob",
      label: "Date of Birth",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "EmailId",
      label: "Email Id",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "ContactNo",
      label: "Mobile No.",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "nomineeminor",
      label: "Is Nominee Minor",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "share",
      label: "% Share",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          return (
            <div className="row">
              {[ApplicationStatus.MemberRegistrationModule_Draft, ApplicationStatus.MemberRegistrationModule_RejectedHRHOD].includes(statusData?.StatusId) ? (
                <a
                  className=""
                  style={{ display: "flex", gap: "10%", marginRight: 10 }}
                  onClick={() => {
                    setDisableAllFields(false);
                    getnomineedetails(id);
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              ) : null}
              <a
                className=""
                style={{ display: "flex", gap: "10%" }}
                onClick={() => {
                  setDisableAllFields(true);
                  getnomineedetails(id);
                }}
              >
                <i className="fas fa-eye"></i>
              </a>
            </div>
          );
        },
      },
    },
  ];

  const getMemberIdStatusDetails = async () => {
    let url = `${getMemberRegistrationStatusByMemberId}`;
    let requestBody = { MemberId: memberid };

    const getData = await APICall(url, requestBody);
    if (getData.Data != null) {
      const IsMemberNomineeDetailsExists = getData.Data.IsMemberNomineeDetailsExists;
      const statusId = getData.Data.StatusId;

      setStatusData(getData.Data);
      setShowNextButton(IsMemberNomineeDetailsExists);

      if ([ApplicationStatus.MemberRegistrationModule_Draft, ApplicationStatus.MemberRegistrationModule_RejectedHRHOD].includes(statusId)) {
        setDisableAllFields(false);
        setDisableAddButton(false);
      } else {
        setDisableAllFields(true);
        setDisableAddButton(true);
      }
    }
  };

  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };
  const handleCloseModal = () => {
    isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
  };
  const onSubmit = async () => {
    debugger
    let errorObj = {};
    if (data.nomineename == "") {
      errorObj = {
        ...errorObj,
        // [data.nomineename]: "This field is Required",
        nomineename: "This field is Required",
      };
    }
    if (data.nomineeminor === true && data.guardianname == "") {
      errorObj = {
        ...errorObj,
        guardianname: "This field is Required",
        // [data.guardianname]: "This field is Required",
      };
    }
    if (data.nomineeminor === true && data.guardianrelation == "") {
      errorObj = {
        ...errorObj,
        guardianrelation: "This field is Required",
        // [data.guardianrelation]: "This field is Required",
      };
    }
    if (data.nomineeminor === true && data.guardianaddress == "") {
      errorObj = {
        ...errorObj,
        guardianaddress: "This field is Required",
        // [data.guardianaddress]: "This field is Required",
      };
    }
    if (data.nomineerelations == null || data.nomineerelations == "") {
      errorObj = {
        ...errorObj,
        nomineerelations: "This field is Required",
      };
    }
    // if (data.nomineerelations == "") {
    //   errorObj = {
    //     ...errorObj,
    //     nomineerelations: "This field is Required",
    //     // [data.nomineerelations]: "This field is Required",
    //   };
    // }
    if (data.dob == null || data.dob == undefined) {
      errorObj = {
        ...errorObj,
        dob: "This field is Required",
        // [data.dob]: "This field is Required",
      };
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(data.EmailId)) {
      errorObj = {
        ...errorObj,
        EmailId: "Invalid email address",
        // [data.EmailId]: "Invalid email address",
      };
    }
    if (data.ContactNo == null || data.ContactNo == undefined) {
      errorObj = {
        ...errorObj,
        ContactNo: "This field is Required",
        // [data.ContactNo]: "This field is Required",
      };
    }
    const mobilePattern = /^[0-9]{10}$/;
    if (!mobilePattern.test(data.ContactNo)) {
      errorObj = {
        ...errorObj,
         ContactNo: "Invalid mobile number",
        // [data.ContactNo]: "Invalid mobile number",
      };
    }

    if (data.dob && moment(data.dob).isAfter(moment().subtract(2, "days"))) {
      errorObj = {
        ...errorObj,
        dob: "Date of Birth should be less than today's data",
        // [data.dob]: "Date of Birth should be less than today's data",
      };
    }
 debugger
    if (data.share == null || data.share == undefined || data.share == "") {
      errorObj = {
        ...errorObj,
        share: "This field is Required",
        // [data.share]: "This field is Required",
      };
    }
    debugger
    if (data.share && data.share == 0) {
      errorObj = {
        ...errorObj,
        // [data.share]: "Share should not be 0%",
        share: "Share should not be 0%",
      };
    }
    if (data.address == null || data.address == "") {
      errorObj = {
        ...errorObj,
          address: "This field is Required",
        // [data.address]: "This field is Required",
      };
    }

    if (griddata.length >= NomineeLimit) {
      notify(1, "Only 3 nominees can be added");
      return;
    }

    if (Object.keys(errorObj).length == 0) {
      showLoader();
      //  const getpercentage = await getGridData()

      let param = {
        Id: nomineeid,
        MemberId: memberid,
        Name: data.nomineename,
        RelationshipWithGaurdian: data.guardianrelation ? data.guardianrelation.label : "",
        DOB: moment(data.dob).format("YYYY-MM-DD"),
        IsMinor: data.nomineeminor,
        SharePercentage: String(data.share),
        IsAgreedTC: false,
        Address: data.address,
        Relationships: data.nomineerelations ? data.nomineerelations.label : "",
        GaurdianName: data.guardianname,
        GaurdianAddress: data.guardianaddress,
        EmailId: data.EmailId,
        ContactNo: data.ContactNo,
      };
      let filterData = griddata.filter((gd) => gd.Id != nomineeid);

      if (filterData.length > 0) {
        let shareCount = 0;
        let totalInsertedShare = 0;
        filterData.forEach((gd) => {
          totalInsertedShare = Number(totalInsertedShare) + Number(gd.share);
        });
        shareCount = Number(data.share) + Number(totalInsertedShare);
        setTotalShare(Number(shareCount));
        if (Number(shareCount) > 100) {
          hideLoader();
          notify(1, "Nominee of Share should not allowed more than 100%");
          return;
        }
      } else {
        if (Number(data.share) > 100) {
          hideLoader();
          notify(1, "Nominee of Share should not allowed more than 100");
          return;
        }
      }
      // if (totalshare + Number(data.share) <= 100) {
      const insertData = await APICall(insertUpdateNomineedetails, param);

      if (insertData.Data != null) {
        notify(0, "Data Save Successfully");
        setShow(false);
        let data1 = {
          nomineename: "",
          nomineerelations: "",
          dob: null,
          nomineeminor: false,
          share: null,
          address: "",
          terms: null,
          guardianname: "",
          guardianrelation: "",
          guardianaddress: "",
          EmailId : "",
          ContactNo : null,
        };
        setData(data1);
        await getMemberIdStatusDetails();
        hideLoader();
        await getGridData();

        //  selectNextTab()
      } else {
        hideLoader();
        notify(1, insertData.Message);
      }
      // } else {
      //   hideLoader();
      //   notify(1, "Nominee of Share should not allowed more than 100");
      // }
    }
    setError(errorObj);
  };

  const onClear = () => {
    setData({
      nomineename: "",
      nomineerelations: null,
      dob: null,
      nomineeminor: false,
      share: "",
      address: "",
      terms: false,
      guardianname: "",
      guardianrelation: null,
      guardianaddress: "",
      EmailId : "",
      ContactNo : null,
    });
  };

  const getGridData = async () => {
    let temp = [];
    let share = 0;
    let param = `${getNomineeDetailsByMemberId}`;
    let requestBody = { MemberId: memberid };
    const insertData = await APICall(param, requestBody);
    // return insertData.Data;
    
    if (insertData.Data != null) {
      insertData.Data.map((d) => {
        let data = {
          nomineename: d.Name,
          nomineerelations: d.Relationships,
          dob: d.DOB,
          nomineeminor: d.IsMinor ? "Yes" : "No",
          address: d.Address,
          share: d.SharePercentage,
          terms: d.IsAgreedTC,
          Id: d.Id,
          EmailId: d.EmailId,  
          ContactNo: d.ContactNo,
        };
        temp.push(data);
        share = share + Number(d.SharePercentage);
        setIsTermsAccepted(d.IsAgreedTC);
        if (d.IsAgreedTC) {
          setIsTermsDisabled(true);
        } else {
          setIsTermsDisabled(false);
        }
      });

      setGridData(temp);
      setTotalShare(share);
    }
    return temp;
  };
  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };
  const getnomineedetails = async (id: number) => {
    setNomineeId(id);
    let api = `${getNomineeDetailsById}`;
    const getdata = await APICall(api, { Id: id });
    
    let nomineeRelationValue = nomineeRelationData.find((nr) => nr.label == getdata.Data.Relationships);
    let gaurdianRelationValue = nomineeRelationData.find((nr) => nr.label == getdata.Data.RelationshipWithGaurdian);
    let obj = {
      nomineename: getdata.Data.Name,
      nomineerelations: nomineeRelationValue,
      dob: getdata.Data.DOB,
      nomineeminor: getdata.Data.IsMinor,
      share: getdata.Data.SharePercentage,
      address: getdata.Data.Address,
      terms: getdata.Data.IsAgreedTC,
      guardianname: getdata.Data.GaurdianName,
      guardianrelation: gaurdianRelationValue,
      guardianaddress: getdata.Data.GaurdianAddress,
      EmailId : getdata.Data.EmailId,
      ContactNo : getdata.Data.ContactNo,
    };
    setData(obj);
    if (
      getdata.Data.StatusId &&
      [ApplicationStatus.MemberRegistrationModule_Draft, ApplicationStatus.MemberRegistrationModule_RejectedHRHOD].includes(getdata.Data.StatusId)
    ) {
      setDisableAddButton(false);
    } else {
      setDisableAddButton(true);
    }
    setShow(true);
  };

  const getRelationDropdownData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.Relationship,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setNomineeRelationData(result.Data);
    }
  };

  const testData = () => {
    if (!enableTestData) {
      return;
    }
    let newData = {
      nomineename: randomString(8),
      nomineerelations: nomineeRelationData[randomNumber(0, nomineeRelationData.length - 1)],
      dob: randomDate(new Date(2005, 1, 1), new Date(2023, 1, 1)),
      nomineeminor: true,
      share: 100,
      address: randomString(50),
      terms: true,
      guardianname: randomString(8),
      guardianrelation: nomineeRelationData[randomNumber(0, nomineeRelationData.length - 1)],
      guardianaddress: randomString(8),
      EmailId : randomEmail(),
      ContactNo : randomMobile(),
    };
    setData(newData);
  };

  return (
    <>
      <div className="">
        <div className="p-2 d-flex justify-content-left" style={{ marginLeft: "7px" }}>
          <ButtonComponent
            icon={"fas fa-sharp fa-solid fa-plus"}
            value={"Add Nominee"}
            id={"saveBtn"}
            onClick={() => {
              setNomineeId(0);
              onClear();
              show === true ? setShow(false) : setShow(true);
            }}
            disabled={false}
          />
        </div>
        {show == true && (
          <>
            <div className="col-lg-12 col-md-12 p-0">
              <div className="row">
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label onDoubleClick={testData}>Nominee Name</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.nomineename}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("nomineename", value);
                      }}
                      onKeyPress={handleKeyNumbers}
                      isDisabled={disableAllFields}
                    />
                    {error.nomineename && <p style={{ color: "red" }}>{error.nomineename}</p>}
                    {/* {error[data.nomineename] && <p style={{ color: "red" }}>{error[data.nomineename]}</p>} */}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Nominee Relation</label>
                    <sup>*</sup>
                    <SelectForm
                      value={data.nomineerelations}
                      placeholder="Select Relation"
                      options={nomineeRelationData}
                      onChange={(val: any) => onChange("nomineerelations", val)}
                      isDisabled={disableAllFields}
                    />
                    {error.nomineerelations && <p style={{ color: "red" }}>{error.nomineerelations}</p>}
                    {/* {error[data.nomineerelations] && <p style={{ color: "red" }}>{error[data.nomineerelations]}</p>} */}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Date of Birth</label>
                    <sup>*</sup>
                    <DateForm
                      isDisabled={disableAllFields}
                      value={data.dob}
                      onChange={(val: any) => {
                        if (moment(val).isAfter(moment().subtract(18, "years"))) {
                          setData({ ...data, nomineeminor: true, dob: val });
                        } else {
                          setData({ ...data, nomineeminor: false, dob: val });
                        }
                      }}
                      maxDate={moment().subtract(2, "days")}
                      isClearable
                    />
                    {error.dob && <p style={{ color: "red" }}>{error.dob}</p>}
                    {/* {error[data.dob] && <p style={{ color: "red" }}>{error[data.dob]}</p>} */}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Email Id</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.EmailId}
                      textArea={false}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("EmailId", value);
                      }}
                      maxlength={200}
                      isDisabled={disableAllFields}
                    />
                    {error.EmailId && <p style={{ color: "red" }}>{error.EmailId}</p>}
                    {/* {error[data.EmailId] && <p style={{ color: "red" }}>{error[data.EmailId]}</p>} */}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.ContactNo}
                      textArea={false}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("ContactNo", value);
                      }}
                      maxlength={200}
                      isDisabled={disableAllFields}
                    />
                    {error.ContactNo && <p style={{ color: "red" }}>{error.ContactNo}</p>}
                    {/* {error[data.ContactNo] && <p style={{ color: "red" }}>{error[data.ContactNo]}</p>} */}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Address</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.address}
                      textArea={true}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("address", value);
                      }}
                      maxlength={200}
                      isDisabled={disableAllFields}
                    />
                    {error.address && <p style={{ color: "red" }}>{error.address}</p>}
                    {/* {error[data.address] && <p style={{ color: "red" }}>{error[data.address]}</p>} */}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="">
                    <label>
                      <input
                        autoComplete={AutoCompleteValue}
                        placeholder={""}
                        value={""}
                        onChange={(val: any) => {
                          let value = val.target.checked;
                          onChange("nomineeminor", value);
                        }}
                        checked={data.nomineeminor}
                        type="checkbox"
                        style={{
                          marginRight: "10px",
                          marginTop: "28px",
                        }}
                        disabled
                      />
                      Nominee is Minor
                    </label>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>% of Share</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.share}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        if (value.length <= 3) {
                          if (value && Number(value) > 100) {
                            setError({
                              ...error,
                              shareValidation: "Number of share should not be greater than 100 %",
                            });
                          } else {
                            setError({
                              ...error,
                              shareValidation: "",
                            });
                          }
                          onChange("share", value);
                        }
                      }}
                      onKeyPress={(e) => handleKeyPress(e)}
                      type="number"
                      isDisabled={disableAllFields}
                      onWheel={(e) => e.target.blur()}
                    />
                    {error.share ? ( <p style={{ color: "red" }}>{error.share}</p>
                    ) : error["shareValidation"] ? (
                      <p style={{ color: "red" }}>{error["shareValidation"]}</p>
                    ) : null}
                     {/* {error[data.share] ? ( <p style={{ color: "red" }}>{error[data.share]}</p>
                    ) : error["shareValidation"] ? (
                      <p style={{ color: "red" }}>{error["shareValidation"]}</p>
                    ) : null} */}
                  </div>
                </div>
                
                {data.nomineeminor === true && (
                  <>
                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <label>Guardian Name</label>
                        <sup>*</sup>
                        <InputForm
                          placeholder={""}
                          value={data.guardianname}
                          onChange={(val: any) => {
                            let value = val.target.value;
                            onChange("guardianname", value);
                          }}
                          onKeyPress={handleKeyNumbers}
                          isDisabled={disableAllFields}
                        />
                        {error[data.guardianname] && <p style={{ color: "red" }}>{error[data.guardianname]}</p>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <label>Guardian Relationship</label>
                        <sup>*</sup>
                        <SelectForm
                          value={data.guardianrelation}
                          placeholder="Select Relation"
                          options={nomineeRelationData}
                          onChange={(val: any) => onChange("guardianrelation", val)}
                          isDisabled={disableAllFields}
                        />
                        {error[data.guardianrelation] && <p style={{ color: "red" }}>{error[data.guardianrelation]}</p>}
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <label>Guardian Address</label>
                        <sup>*</sup>
                        <InputForm
                          placeholder={""}
                          value={data.guardianaddress}
                          onChange={(val: any) => {
                            let value = val.target.value;
                            onChange("guardianaddress", value);
                          }}
                          textArea={true}
                          maxlength={200}
                          isDisabled={disableAllFields}
                        />
                        {error[data.guardianaddress] && <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>}
                      </div>
                    </div>
                  </>
                )}
              </div>
              {!disableAllFields ? (
                <div className="d-flex justify-content-end">
                  <div style={{ marginRight: 10 }}>
                    <ButtonComponent icon={"fa-solid fa-remove"} value={"Clear"} onClick={onClear} disabled={disableAllFields} />
                  </div>
                  <ButtonComponent icon={"fa-solid fa-floppy-disk"} value={"Save"} id={"saveBtn"} onClick={onSubmit} disabled={disableAllFields} />
                </div>
              ) : null}
            </div>
          </>
        )}

        {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0">
          <div className="col-lg-12 p-0">
            <div className="row">
              <div className="col-lg-4 col-md-4"></div>
              <div className="col-lg-4 col-md-2"></div>
              <div className="col-lg-4 col-md-6">
                <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                  <div className="col-lg-12 mt-1 p-0 searchInput">
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="p-3">
          <DynamicGrid options={dashboardOptions} data={griddata} columns={dashboardGridColumns} />
        </div>
        <div className="p-2 d-flex justify-content-left">
          <div className="">
            <div className="" style={{ marginLeft: "10px" }}>
              <input
                autoComplete={AutoCompleteValue}
                placeholder={""}
                value={""}
                checked={isTermsAccepted}
                onChange={(val: any) => {
                  let value = val.target.checked;
                  // onChange("terms", value);
                  setIsTermsAccepted(value);
                }}
                type="checkbox"
                disabled={isTermsDisabled}
              />{" "}
            </div>
          </div>
          <span style={{ marginLeft: "12px" }} className="d-flex">
            I agree to&nbsp;
            <BaseModal
              buttonText={"terms & conditions"}
              open={isModalOpen}
              content={
                <ModalDesign
                  message={
                    termscondition.length > 0 &&
                    termscondition.map((d, index) => (
                      <div>
                        {index + 1}. {d}
                      </div>
                    ))
                  }
                  closefunc={handleCloseModal}
                />
              }
              onclose={handleCloseModal}
            />
          </span>{" "}
          {/* <sup>*</sup> */}
          {error["terms"] && <p style={{ color: "red" }}>{error["terms"]}</p>}
        </div>
        <div className="d-flex justify-content-end">
          <ButtonComponent icon={"fas fa-arrow-left"} value={"Back"} onClick={selectPreviousTab} />
          <ButtonComponent icon={"far fa-times-circle"} value={"Exit"} style={{ marginLeft: "10px" }} className="btn btn-primary" onClick={() => navigate("/")} />
          {griddata ? ( // isTermsAccepted &&
            <ButtonComponent
              icon={"fas fa-arrow-right"}
              value={"Next"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={async () => {
                showLoader();
                if (Number(totalshare) == 100 && isTermsAccepted) {
                  if (!isTermsDisabled) {
                    const insertData = await APICall(insertUpdateNomineeIsAgreedTC, {
                      MemberId: memberid,
                      IsAgreedTC: true,
                    });
                    if (insertData.Data != null) {
                      await selectNextTab();
                    } else {
                      hideLoader();
                      notify(1, insertData.Message);
                    }
                  } else {
                    await selectNextTab();
                  }

                  hideLoader();
                } else if (Number(totalshare) < 100) {
                  if (griddata.length == 0) {
                    notify(1, "Please Add atleast 1 nominee with share of 100%");
                  } else {
                    notify(1, "Nominee of Share should be 100%");
                  }
                } else if (Number(totalshare) > 100) {
                  if (griddata.length == 0) {
                    notify(1, "Please Add atleast 1 nominee with share of 100%");
                  } else {
                    notify(1, "Nominee of Share should not allowed more than 100%");
                  }
                } else {
                  notify(1, "Please Agree Terms & Conditions");
                }

                hideLoader();
              }}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};
export default NomineeDetails;

const ModalDesign = ({ message, closefunc }) => {
  return (
    <>
      <label
        className="d-block"
        style={{
          fontWeight: "bold",
          marginBottom: "10px",
          fontFamily: "var(--bs-body-font-family)",
          fontSize: "var(--bs-body-font-size)",
        }}
      >
        {"Terms & Conditions"}
      </label>
      {/* <label className="d-block" style={{ marginBottom: "10px",fontFamily: "var(--bs-body-font-family)",
   fontSize: "var(--bs-body-font-size)" }}> */}
      {message}
      {/* </label> */}
      <div className="row justify-content-end no-gutters  ">
        <div className="col-auto">
          <button
            onClick={closefunc}
            // style={{ margin: "5px" }}
            className="btn btn-secondary btn-sm"
          >
            OK
          </button>
        </div>
      </div>
    </>
  );
};
